import { Component, OnInit } from '@angular/core';
import { ClienteLogin } from '../login/cliente_login';
import { Router } from "@angular/router";
import {SessionTokenService} from "../../components/common/utils/sessionToken.service";
import {HandleError} from "../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";

declare var jQuery: any;

@Component({
    selector: 'mainViewEmpresa',
    templateUrl: 'main-view-empresa.template.html'
})
export class mainViewComponentEmpresa implements OnInit {
    usuario: ClienteLogin;
    constructor(private sessionStorageService: SessionStorageService,private router: Router, private sessionTokenService: SessionTokenService, private handleError: HandleError) { }
    ngOnInit(): void {
        /*correctHeight();
        detectBody();*/
        let cliente=this.getParameterByName("cliente");
          if(cliente!=null){
            this.sessionStorageService.store("clienteMaestra",cliente);
            this.sessionStorageService.store("clienteMaestra1",cliente);
    
           }
          console.log(cliente)
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
        if (this.usuario == null){
            let error = {"status":998,"message":"Entrada no permitida"};
            this.handleError.redirectUrl(error);
        }
        //let bandera = this.sessionTokenService.useJwtHelper();
    }
    private getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/main-view-empresa/main-view-empresa.component.ts